/* eslint @typescript-eslint/no-var-requires: "off" */
const { Swiper, SwiperSlide } = require('swiper/react');
const { SwiperProps } = require('swiper/react');

import 'swiper/css';
import 'swiper/css/free-mode';

import './styles.css';

import { cn } from '@/lib/utils';

export type CarouselRenderItemInfo<ItemType> = {
  item: ItemType;
  index: number;
};

export type CarouselRenderItem<ItemType> = ({
  item,
  index,
}: CarouselRenderItemInfo<ItemType>) => React.ReactElement<any> | null;

export interface CarouselProps<ItemType> {
  config: typeof SwiperProps;
  items: ItemType[];
  renderItem: CarouselRenderItem<ItemType>;
  sideGradient?: boolean;
  classNames?: {
    root?: string;
  };
}

export type CarouselInstance = typeof Swiper;

export const Carousel = <ItemType,>({
  config,
  items,
  renderItem,
  sideGradient = true,
  classNames,
}: CarouselProps<ItemType>) => {
  return (
    <div
      className={cn(
        sideGradient && 'carousel-side-gradient',
        'max-section-width flex w-full after:z-10',
        classNames?.root
      )}
    >
      <Swiper {...config}>
        {items.map((item, i) => (
          <SwiperSlide key={i}>{renderItem({ item, index: i })}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
